import { createAction } from 'redux-actions'

export const GET_CATEGORIES = createAction('GET_CATEGORIES')
export const GET_CATEGORIES_START = createAction('GET_CATEGORIES_START')
export const GET_CATEGORIES_SUCCESS = createAction('GET_CATEGORIES_SUCCESS')
export const GET_CATEGORIES_ERROR = createAction('GET_CATEGORIES_ERROR')
export const GET_CATEGORIES_FINALLY = createAction('GET_CATEGORIES_FINALLY')